<template>
  <div>
    <div :id="modalId"
         :class="['reveal-modal', 'open', modalClass]"
         :aria-labelledby="titleId"
         aria-hidden="false"
         role="dialog"
         tabindex="-1">
      <div class="modal-content">
        <slot/>
        <button :aria-label="$t('generic.close')"
                class="close-reveal-modal"
                data-close=""
                type="button"
                @click.prevent="close()">
          <span aria-hidden="true">&#xe616;</span>
        </button>
      </div>
    </div>
    <div class="reveal-modal-bg" style="display: block;" @click.prevent="close"/>
  </div>
</template>

<script>
import {getFocusables} from '../../utils/focusable'

export default {
  props: {
    modalClass: {
      type: String,
      required: false,
      default: null
    },
    modalId: {
      type: String,
      required: false,
      default: null
    },
    titleId: {
      type: String,
      required: false,
      default: null
    },
    manualFocus: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      manuallyFocusedElement: null
    }
  },
  mounted: function () {
    document.body.appendChild(this.$el)
    this.addStyle()
    this.$nextTick(function () {
      const focusables = getFocusables(this.$el)
      if (focusables.length > 0 && !this.manualFocus) {
        focusables[0].focus()
      }
      const component = this
      for (const focusable of focusables) {
        focusable.addEventListener('focus', function () {
          component.manuallyFocusedElement = focusable
        })
      }
      this.$el.addEventListener('keydown', (event) => this.keyDownEvents(event))
    })
  },
  updated: function () {
    const focusables = getFocusables(this.$el)
    if (focusables.length > 0) {
      if (this.manuallyFocusedElement === null && !this.manualFocus) {
        focusables[0].focus()
      }
    }
  },
  destroyed: function () {
    this.removeStyle()
    try {
      this.$el.removeEventListener('keydown', (event) => this.keyDownEvents(event))
      document.body.removeChild(this.$el)
    } catch (error) {
      // probably not there yet, ignore
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    },
    htmlElement: function () {
      return document.getElementsByTagName('html')[0]
    },
    offCanvasWrapElement: function () {
      return document.getElementById('off-canvas-wrap')
    },
    addStyle: function () {
      this.htmlElement().setAttribute('style', 'height: 100%; position: fixed; top: 0px; left: 0px;')
      this.offCanvasWrapElement().setAttribute('style', 'height: 100%; position: fixed; top: 0px; left: 0px;')
    },
    removeStyle: function () {
      this.htmlElement().removeAttribute('style')
      this.offCanvasWrapElement().removeAttribute('style')
    },
    keyDownEvents: function (event) {
      const isTab = event.which === 9 && !event.shiftKey
      const isShiftTab = event.which === 9 && event.shiftKey
      const isEscape = event.which === 27

      if (isEscape) {
        this.close()
      }

      if (isTab || isShiftTab) {
        const focusables = getFocusables(this.$el)
        const firstFocusable = focusables[0]
        const lastFocusable = focusables[focusables.length - 1]

        if (isShiftTab && event.target === firstFocusable) {
          lastFocusable.focus()
          event.preventDefault()
        }
        if (isTab && event.target === lastFocusable) {
          firstFocusable.focus()
          event.preventDefault()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/Modal.vue